module.exports = __webpack_public_path__ + "img/grey-cardinal-1.0a7b3f3e.svg";